var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrefilledMandate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#DDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5003 24.9596H13.5003C8.97533 24.9596 7.04199 23.0263 7.04199 18.5013V13.5013C7.04199 8.9763 8.97533 7.04297 13.5003 7.04297H17.667C18.0087 7.04297 18.292 7.3263 18.292 7.66797C18.292 8.00964 18.0087 8.29297 17.667 8.29297H13.5003C9.65866 8.29297 8.29199 9.65964 8.29199 13.5013V18.5013C8.29199 22.343 9.65866 23.7096 13.5003 23.7096H18.5003C22.342 23.7096 23.7087 22.343 23.7087 18.5013V14.3346C23.7087 13.993 23.992 13.7096 24.3337 13.7096C24.6753 13.7096 24.9587 13.993 24.9587 14.3346V18.5013C24.9587 23.0263 23.0253 24.9596 18.5003 24.9596Z",
    fill: "#1177BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3337 14.9584H21.0003C18.1503 14.9584 17.042 13.8501 17.042 11.0001V7.66674C17.042 7.41674 17.192 7.18341 17.4253 7.09174C17.6587 6.99174 17.9253 7.05007 18.1087 7.22507L24.7753 13.8917C24.9503 14.0667 25.0087 14.3417 24.9087 14.5751C24.8087 14.8084 24.5837 14.9584 24.3337 14.9584ZM18.292 9.17507V11.0001C18.292 13.1501 18.8503 13.7084 21.0003 13.7084H22.8253L18.292 9.17507Z",
    fill: "#1177BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1663 20.793H11.833C11.4913 20.793 11.208 20.5096 11.208 20.168C11.208 19.8263 11.4913 19.543 11.833 19.543H15.1663C15.508 19.543 15.7913 19.8263 15.7913 20.168C15.7913 20.5096 15.508 20.793 15.1663 20.793Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrefilledMandate);
export default __webpack_public_path__ + "static/media/prefilled-mandate.1a8a073161c6ec4e717f7dd081a4579b.svg";
export { ForwardRef as ReactComponent };